const conceptScroll = (() => {
  const pageConcept = (document.getElementById("pageConcept") != null);
  if (pageConcept) {



    let sW = window.innerWidth;
    // let sH = window.innerHeight;


    let jsSecTown = document.getElementById("jsSecTown")


    if (sW >= 768) {

      let scrollWrap = jsSecTown.querySelector(".js-scroll-wrap")
      let scrollBox = jsSecTown.querySelectorAll(".js-scroll-box")

      let scrollWrapW = scrollWrap.clientWidth;
      let scrollBoxW = scrollBox[0].clientWidth;


      let moveGap = scrollBoxW - scrollWrapW
      // console.log(moveGap);


      document.addEventListener("DOMContentLoaded", () => {

        gsap.to(scrollBox, {
          left: -moveGap,
          scrollTrigger: {
            trigger: scrollWrap,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            onEnter: () => {
              // console.log('enter')
            },
            onLeave: () => {
              // console.log('leave')
            },
            onEnterBack: () => {
              // console.log('enter back')
            },
            onLeaveBack: () => {
              // console.log('leave back')
            },
            // markers: true,
          }
        });

      });

    } else {

      let jsSwiper = jsSecTown.querySelectorAll(".js-swiper")

      const swiper0 = new Swiper(jsSwiper[0], {
  
        slidesPerView: 0.5, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        spaceBetween: 0, // スライド間の余白（px）
        // centeredSlides: true, // アクティブなスライドを中央に配置する

        loop: true,  // 無限ループさせる
        loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数

        speed: 35000, // スライドアニメーションのスピード（ミリ秒）

        autoplay: { // 自動再生させる
          delay: 0, // 次のスライドに切り替わるまでの時間（ミリ秒）
          disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
          waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
        },
      });

      const swiper1 = new Swiper(jsSwiper[1], {
  
        slidesPerView: 0.5, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        spaceBetween: 0, // スライド間の余白（px）
        // centeredSlides: true, // アクティブなスライドを中央に配置する

        loop: true,  // 無限ループさせる
        loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数

        speed: 40000, // スライドアニメーションのスピード（ミリ秒）

        autoplay: { // 自動再生させる
          delay: 0, // 次のスライドに切り替わるまでの時間（ミリ秒）
          disableOnInteraction: false, // ユーザーが操作しても自動再生を止めない
          waitForTransition: false, // アニメーションの間も自動再生を止めない（最初のスライドの表示時間を揃えたいときに）
        },
      });


    }





  }
})()
export default conceptScroll;